import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import type { FuelSurchargeWeek } from './types';

export * from './types';
export * from './pickSurcharge';

/**
 * The EIA-derived fuel surcharge weeks — the same public feed the website widget
 * reads. Updated weekly, so it's cached for an hour and not refetched on focus.
 */
export function useFuelSurcharge(enabled = true) {
  return useQuery<FuelSurchargeWeek[]>({
    queryKey: ['fuel-surcharge'],
    queryFn: async () => {
      const { data } = await api.get<FuelSurchargeWeek[]>('/fuel-surcharge');
      return data;
    },
    enabled,
    staleTime: 60 * 60 * 1000,
    gcTime: 2 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
